import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentMethodSelector = ({ 
  selectedMethod, 
  onMethodSelect, 
  disabled = false 
}) => {
  const paymentMethods = [
    {
      id: 'pago_movil',
      name: 'Pago Móvil',
      description: 'Transferencia desde tu banco móvil',
      icon: 'Smartphone',
      color: 'bg-blue-500/10 border-blue-500/20 text-blue-500',
      instructions: 'Realiza la transferencia desde tu app bancaria y sube el comprobante',
      bankInfo: {
        bank: 'Banco Provincial',
        phone: '0412-2697055',
        cedula: 'V-26572027',
        name: 'Aurea Fortuna C.A',
      }
    },
    {
      id: 'zelle',
      name: 'Zelle',
      description: 'Pago internacional en USD',
      icon: 'DollarSign',
      color: 'bg-purple-500/10 border-purple-500/20 text-purple-500',
      instructions: 'Envía el pago a nuestro email registrado en Zelle',
      bankInfo: {
        email: 'proximamente disponible',
        name: 'proximamente disponible',
        rate: 'proximamente disponible'
      }
    },
    {
      id: 'binance',
      name: 'Binance Pay',
      description: 'Criptomonedas (USDT, BTC)',
      icon: 'Coins',
      color: 'bg-orange-500/10 border-orange-500/20 text-orange-500',
      instructions: 'Transfiere a nuestra wallet y proporciona el hash de transacción',
      bankInfo: {
        wallet: 'proximamente disponible',
        network: 'proximamente disponible',
        rate: 'proximamente disponible'
      }
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-luxury">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 bg-secondary/10 rounded-lg">
          <Icon name="CreditCard" size={20} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-semibold text-gray-800">
            Método de Pago
          </h3>
          <p className="text-sm text-gray-800 font-caption">
            Selecciona tu método de pago preferido
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {paymentMethods.map((method) => (
          <div
            key={method.id}
            onClick={() => !disabled && onMethodSelect(method.id)}
            className={`relative p-4 rounded-lg border-2 cursor-pointer transition-premium ${
              selectedMethod === method.id
                ? 'border-secondary bg-secondary/5 shadow-golden'
                : 'border-border hover:border-secondary/50 hover:bg-muted/30'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <div className="flex items-center space-x-3 mb-3">
              <div className={`p-2 rounded-lg ${method.color}`}>
                <Icon name={method.icon} size={20} />
              </div>
              <div>
                <h4 className="font-body font-semibold text-gray-800">
                  {method.name}
                </h4>
                <p className="text-xs text-gray-800 font-caption">
                  {method.description}
                </p>
              </div>
            </div>

            {selectedMethod === method.id && (
              <div className="absolute top-2 right-2">
                <div className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center">
                  <Icon name="Check" size={14} className="text-secondary-foreground" />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {selectedMethod && (
        <div className="bg-muted/30 rounded-lg p-4 border border-golden/20">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={16} className="text-secondary mt-0.5" />
            <div>
              <h4 className="font-body font-medium text-gray-800 text-sm mb-2">
                Instrucciones de Pago
              </h4>
              <p className="text-sm text-gray-800 font-caption mb-3">
                {paymentMethods.find(m => m.id === selectedMethod)?.instructions}
              </p>
              
              <div className="bg-card rounded-lg p-3 border border-border">
                <h5 className="font-body font-medium text-gray-800 text-xs mb-2">
                  Datos para la transferencia:
                </h5>
                {(() => {
                  const method = paymentMethods.find(m => m.id === selectedMethod);
                  const bankInfo = method?.bankInfo;
                  
                  return (
                    <div className="space-y-1 text-xs font-mono">
                      {bankInfo?.bank && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Banco:</span>
                          <span className="text-gray-800">{bankInfo.bank}</span>
                        </div>
                      )}
                      {bankInfo?.phone && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Teléfono:</span>
                          <span className="text-gray-800">{bankInfo.phone}</span>
                        </div>
                      )}
                      {bankInfo?.cedula && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Cédula:</span>
                          <span className="text-gray-800">{bankInfo.cedula}</span>
                        </div>
                      )}
                      {bankInfo?.email && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Email:</span>
                          <span className="text-gray-800">{bankInfo.email}</span>
                        </div>
                      )}
                      {bankInfo?.wallet && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Wallet:</span>
                          <span className="text-gray-800 break-all">{bankInfo.wallet}</span>
                        </div>
                      )}
                      {bankInfo?.network && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Red:</span>
                          <span className="text-gray-800">{bankInfo.network}</span>
                        </div>
                      )}
                      {bankInfo?.name && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Titular:</span>
                          <span className="text-gray-800">{bankInfo.name}</span>
                        </div>
                      )}
                      {bankInfo?.rate && (
                        <div className="flex justify-between">
                          <span className="text-gray-800">Tasa:</span>
                          <span className="text-secondary font-bold">{bankInfo.rate}</span>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodSelector;